import { render } from "./SVGSeparatorAdd.vue?vue&type=template&id=514706c2"
import script from "./SVGSeparatorAdd.vue?vue&type=script&lang=js"
export * from "./SVGSeparatorAdd.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__